<div id="maskLayer" style="display: none;">
    
</div>
<div id="load" style="display: none;">
    <div>加</div>
    <div>载</div>
    <div>中</div>
    <div>.</div>
    <div>.</div>
    <div>.</div>
</div>